import "./QICustomerDetailsForm.scss";
import { useState, useEffect } from "react";
import FormFieldWithLabel from "../FormFieldWithLabel/FormFieldWithLabel.jsx";
import { produce } from "immer";
import { DEALERSHIP_CONFIG } from "../../config/dealershipConfig.js";
import { useDealershipContext } from "../../contexts/dealershipContext.jsx";
import { ANR_ID } from "../../constants/dealershipIds.js";

export default function QICustomerDetailsForm({
  dealershipId,
  currentQuestionViewIndex,
  quizQuestions,
  setQuizQuestions,
  childIndex,
}) {
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const { salesPersonInfo, changeSalesPersonInfo } = useDealershipContext();
  const [salesPerson, setSalesPerson] = useState(salesPersonInfo.name);
  const salesDropdownInfo = DEALERSHIP_CONFIG[dealershipId].salesPeople;
  const isNissanRichmond = dealershipId === ANR_ID;
  const isMorrey = dealershipId.toLowerCase().startsWith("morrey");
  const hasPostalCode =
    quizQuestions[currentQuestionViewIndex].children[0].hasPostalCode;

  const getSalesPersonByName = (targetName) => {
    for (const key in salesDropdownInfo) {
      if (salesDropdownInfo[key].name === targetName) {
        return salesDropdownInfo[key];
      }
    }
    return null;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setQuizQuestions(
      produce((quizQuestionsDraft) => {
        quizQuestionsDraft[currentQuestionViewIndex].children[
          childIndex
        ].salesPersonInfo = salesPersonInfo.name;
      })
    );
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      setEmailError("Invalid Email");
      return false;
    }
    setEmailError("");
    return true;
  };

  const validatePhoneNo = (phoneNo) => {
    const phoneNoRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    if (phoneNo && !phoneNoRegex.test(phoneNo)) {
      setPhoneNoError("Invalid phone number");
      return false;
    }
    setPhoneNoError("");
    return true;
  };

  const validatePostalCode = (PostalCode) => {
    const PostalCodeRegex = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
    if (PostalCode && !PostalCodeRegex.test(PostalCode)) {
      setPostalCodeError("Invalid postal code");
      return false;
    }
    setPostalCodeError("");
    return true;
  };
  const nissanRichmondOptions = [
    { value: "referral", label: "Referral" },
    { value: "walkin", label: "Walkin" },
    { value: "autotrader", label: "Autotrader" },
    { value: "cargurus", label: "Cargurus" },
    { value: "fbMarketplace", label: "Facebook Marketplace" },
    { value: "instagram", label: "Instagram" },
    { value: "returnCustomer", label: "Return Customer" },
    { value: "google", label: "Google" },
    { value: "autoalert", label: "AutoAlert" },
    { value: "other", label: "Other" },
  ];

  const morreyOptions = [
    { value: "liveNearby", label: "Live near by / In the Neighbourhood" },
    { value: "website", label: "Website" },
    { value: "facebookMarketplace", label: "Facebook Marketplace" },
    { value: "autotrader", label: "Autotrader" },
    { value: "cargurus", label: "Cargurus" },
    { value: "google", label: "Google" },
    { value: "youtube", label: "YouTube" },
    { value: "referral", label: "Referral / Word of Mouth" },
    { value: "service", label: "Service" },
    { value: "other", label: "Other" },
  ];

  let whereDidYouHearOptions = [];
  if (isNissanRichmond) whereDidYouHearOptions = nissanRichmondOptions;
  else if (isMorrey) whereDidYouHearOptions = morreyOptions;
  const shouldShowWhereDidYouHearDropdown = isNissanRichmond || isMorrey;

  return (
    <>
      <div className="combine-fields">
        <FormFieldWithLabel
          label="First Name"
          type="text"
          id="first-name"
          placeholder="John"
          value={
            quizQuestions[currentQuestionViewIndex].children[childIndex]
              .firstName
          }
          onChange={(e) => {
            e.target.value.length > 0
              ? setFirstNameError("")
              : setFirstNameError("Required Field");
            setQuizQuestions(
              produce((quizQuestionsDraft) => {
                quizQuestionsDraft[currentQuestionViewIndex].children[
                  childIndex
                ].firstName = e.target.value;
              })
            );
          }}
          errorMessage={firstNameError}
        />
        <FormFieldWithLabel
          label="Last Name"
          type="text"
          id="last-name"
          placeholder="Terry"
          value={
            quizQuestions[currentQuestionViewIndex].children[childIndex]
              .lastName
          }
          onChange={(e) => {
            e.target.value.length > 0
              ? setLastNameError("")
              : setLastNameError("Required Field");
            setQuizQuestions(
              produce((quizQuestionsDraft) => {
                quizQuestionsDraft[currentQuestionViewIndex].children[
                  childIndex
                ].lastName = e.target.value;
              })
            );
          }}
          errorMessage={lastNameError}
        />
      </div>
      <FormFieldWithLabel
        label="Email"
        type="text"
        id="email"
        placeholder="johnterry@hotmail.com"
        value={email}
        onChange={(e) => {
          if (validateEmail(e.target.value)) {
            setQuizQuestions(
              produce((quizQuestionsDraft) => {
                quizQuestionsDraft[currentQuestionViewIndex].children[
                  childIndex
                ].email = e.target.value;
              })
            );
          }
          setEmail(e.target.value);
        }}
        errorMessage={emailError}
      />
      <FormFieldWithLabel
        label="Phone No."
        type="text"
        id="phone-no"
        placeholder="604 888 8888"
        value={phoneNo}
        onChange={(e) => {
          if (validatePhoneNo(e.target.value)) {
            setQuizQuestions(
              produce((quizQuestionsDraft) => {
                quizQuestionsDraft[currentQuestionViewIndex].children[
                  childIndex
                ].phoneNo = e.target.value;
              })
            );
          }
          setPhoneNo(e.target.value);
        }}
        errorMessage={phoneNoError}
      />
      <div className="combine-fields">
        {hasPostalCode && (
          <FormFieldWithLabel
            label="Postal Code"
            type="text"
            id="postal-code"
            placeholder="M4C 5M6"
            value={postalCode}
            onChange={(e) => {
              if (validatePostalCode(e.target.value)) {
                setQuizQuestions(
                  produce((quizQuestionsDraft) => {
                    quizQuestionsDraft[currentQuestionViewIndex].children[
                      childIndex
                    ].postalCode = e.target.value;
                  })
                );
              }
              setPostalCode(e.target.value);
            }}
            errorMessage={postalCodeError}
          />
        )}

        {shouldShowWhereDidYouHearDropdown && (
          <div className="dropdown-group">
            <label htmlFor="how-did-you-hear-about-us">
              How did you hear about us?
            </label>
            <select
              value={
                quizQuestions[currentQuestionViewIndex].children[childIndex]
                  .whereDidYouHereAboutUs
              }
              onChange={(e) => {
                setQuizQuestions(
                  produce((quizQuestionsDraft) => {
                    quizQuestionsDraft[currentQuestionViewIndex].children[
                      childIndex
                    ].whereDidYouHereAboutUs = e.target.value;
                  })
                );
              }}
              className="dropdown"
            >
              <option value=""></option>
              {whereDidYouHearOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="dropdown-group">
        <label htmlFor="contact-type">Sales Person</label>
        <select
          value={salesPerson}
          onChange={(e) => {
            const salesPersonDetails = getSalesPersonByName(e.target.value);
            changeSalesPersonInfo(salesPersonDetails);
            setSalesPerson(salesPersonDetails.name);
            setQuizQuestions(
              produce((quizQuestionsDraft) => {
                quizQuestionsDraft[currentQuestionViewIndex].children[
                  childIndex
                ].salesPersonInfo = e.target.value;
              })
            );
          }}
          className="dropdown"
        >
          {Object.keys(salesDropdownInfo).map((salesPersonNumber, index) => {
            return (
              <option
                key={index}
                value={salesDropdownInfo[salesPersonNumber].name}
              >
                {salesDropdownInfo[salesPersonNumber].name}
              </option>
            );
          })}
        </select>
      </div>
    </>
  );
}
